import React, {Component} from "react";
import moment from "moment";
import User from "../../api/User";
import Appointment from "../../api/Appointment";
import Clinic from "../../api/Clinic";
import AccountService from "../../api/services/AccountService";
import './GroupedDateListView.css';



const account = new AccountService();

const style = `

.table {
    display: table;
}

.table.hmax, .table .hmax, .hmax {
    width: 100%;
}

.table.vmax, .table .vmax {
    height: 100%;
}

.table.layout-auto, .layout-auto {
    table-layout: auto;
}

.table.layout-fixed, .layout-fixed {
    table-layout: fixed;
}

.table.inline {
    display: inline-table;
}

.table > * {
    display: table-row;
    /* width: inherit; */
}

.table > * > * {
    display: table-cell;
    position: relative;
    /* width: inherit; */
}

.table.align-middle > * > *,
.table.align-middle > * > * > *,
.align-middle {
    vertical-align: middle;
}

table.align-top > * > *,
table.align-top > * > * > *,
align-top {
    vertical-align: top;
}



.table.align-bottom > * > *,
.table.align-bottom > * > * > *,
.align-bottom {
    vertical-align: bottom;
}

.table.align-left > * > *,
.align-left {
    text-align: left;
}

.table.align-center > * > *,
.align-center {
    text-align: center;
}

.table.align-right > * > *,
.align-right {
    text-align: right;
}

.grouped-list-view{
    font-family: 'Open Sans', sans-serif;
}

.app-list-item{
	border-spacing:20px 15px;
	margin:3px 0px;
	font-size: 12px;
}

	.app-list-item.no-show{
	background-color: #E1E1E1;
}

	.app-list-item.cancelled{
	background-color: #C60E0E;
	color: #fff;
}

	.app-list-item a{
	cursor: pointer;
}

	.app-list-item a:hover {
	text-decoration: underline;
}

table {
    margin-bottom: 20px;
    font-size: 14px;
}

table td {
    padding: 5px
}

table th {
    background-color: #e3e3e3;
    padding: 5px;
}

table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}

td {
    overflow-wrap: break-word;
}



`

export default class GroupedDateListView extends Component{

	getHeaderSuffix = () => {
		return this.props.headerSuffix || '';
	}

	parseIntoGroups(list) {
		let json = list;
		let groups = {};
		let items = [];
		json.sort((a, b) => {
			if (moment(a.start).isSame(moment(b.start))) return 0;
			return (moment(a.start).isBefore(moment(b.start))) ? -1 : 1;
		});
		for (let i = 0; i < json.length; i++) {
			let app = json[i];
			let groupId = moment(app.start).format('ddd MMM D, YYYY');
			if (groups[groupId] === undefined) {
				groups[groupId] = [];
			}

			groups[groupId].push(<AppListItem id={i} app={json[i]} onReschedule={this.handleReschedule}/>);
		}

		for (let p in groups) {
			items.push(
				<table id={p} className='list-group hmax align-top align-left layout-fixed'>
					<thead>
						<tr>
							<th colSpan={4}>{p + (this.props.headerSuffix || '')}</th>
						</tr>
						<tr>
							<th>Appointment</th>
							<th>Patient</th>
							{/*<th>Pedorthist</th>*/}
							<th>Status</th>
							<th>Notes</th>
						</tr>
					</thead>
					<tbody>
						{groups[p]}
					</tbody>

				</table>
			)
		}

		/*for (let p in groups) {
			items.push(
				<div id={p} className='list-group'>
					<h2>{p}</h2>
					<div className={'app-list-item table hmax align-top layout-fixed header'}>
						<div>
							<div>Appointment</div>
							<div>Clinic</div>
							<div>Pedorthist</div>
							<div>Status</div>
							<div>Notes</div>
						</div>
					</div>
					{groups[p]}
				</div>
			)
		}*/

		if (items.length === 0) {
			items.push(<div className='noshow-no-items'>No items found!</div>)
		}

		return items;
	}

	render(){
		const list = this.parseIntoGroups(this.props.apps || []);
		//console.log('GroupedDateList:', this);
		return (
			<div className={'grouped-list-view'}>

				<style dangerouslySetInnerHTML={{__html: style}} />
				<div className='container list-holder'>
					{list}
				</div>
			</div>

		)
	}
}


class AppListItem extends Component {

	handleReschedule = () => {
		if (this.props.onReschedule) {
			this.props.onReschedule(this.props.app);
		}
	}

	render() {
		let app = new Appointment(this.props.app);
		let client = new User(app.client);
		let time = Appointment.FormatTimeRange(app);
		let contact = User.GetContact(client);
		console.log('Contact:', contact);
		console.log('App:', app);


		let clinic = new Clinic(app.clinicId);
		let doctor = clinic.getDoctor(app.userId);
		return (
			<tr>
				<td>{time}<br/>{app.appointmentType.name}</td>
				<td>{client.fullName}<br/><span style={{fontSize: "smaller"}}>{contact? `${contact.name}: ${contact.value}`: ''}</span></td>
				{/*<td>{doctor.fullName}</td>*/}
				<td>{app.status}</td>
				<td>{app.comment}</td>
			</tr>
		)
		/*return (
			<div className={'app-list-item table hmax align-top layout-fixed ' + app.status.toLowerCase()}>
				<div>
					<div>{client.fullName}<br/>{time}</div>
					<div>{account.clinicName}</div>
					<div>{doctor.fullName}</div>
					<div>{app.status}</div>
					<div>{app.comment}</div>
				</div>
			</div>
		)*/
	}
}



// WEBPACK FOOTER //
// ./src/components/listViews/GroupedDateListView.jsx